const createSorter = (field, isDate = false, isArray = false) => {
  return (a, b) => {
    // 处理 null/undefined 情况
    if (a[field] == null && b[field] == null) return 0;
    if (a[field] == null) return 1;  // null 值排在后面
    if (b[field] == null) return -1; // null 值排在后面
    
    // 处理数组类型
    if (isArray) {
      const aValue = Array.isArray(a[field]) ? a[field].join(', ') : '';
      const bValue = Array.isArray(b[field]) ? b[field].join(', ') : '';
      return aValue.localeCompare(bValue);
    }
    
    // 处理日期类型
    if (isDate) {
      return new Date(a[field]) - new Date(b[field]);
    }
    
    // 处理数字类型
    if (typeof a[field] === 'number' && typeof b[field] === 'number') {
      return a[field] - b[field];
    }
    
    // 默认字符串比较
    return String(a[field]).localeCompare(String(b[field]));
  };
};

export default createSorter;